import { useT } from '../../i18n';
import { selectStation, useAppStore } from '../../store/useAppStore';
import { formatClock, TIMER_PRESETS, useTimerStore } from '../../store/useTimerStore';
import { Dialog } from '../../ui/Dialog';
import { Icon } from '../../ui/Icon';
import styles from './TimerDialog.module.css';

/** Stationszeit: Stand, Steuerung, Dauer-Vorwahl. */
export function TimerDialog() {
  const t = useT();
  const closeSheet = useAppStore((s) => s.closeSheet);
  const setTimerShow = useAppStore((s) => s.setTimerShow);
  const station = useAppStore(selectStation);

  const left = useTimerStore((s) => s.left);
  const total = useTimerStore((s) => s.total);
  const running = useTimerStore((s) => s.running);
  const armLeft = useTimerStore((s) => s.armLeft);
  const press = useTimerStore((s) => s.press);
  const reset = useTimerStore((s) => s.reset);
  const setTotal = useTimerStore((s) => s.setTotal);

  const armed = armLeft > 0;
  // Bei 0:00 stellt der Knopf auf Anfang (`press`), also zeigt er das auch.
  const zurueck = armed || left === 0;
  const state = left === 0 ? t.timer.expired : running ? t.timer.running : t.timer.paused;

  // Die eigene Dauer der Station steht immer zur Wahl — sonst passt keine der festen
  // Vorwahlen zur geladenen Prüfung und es wirkt, als sei nichts eingestellt.
  const presets = Array.from(new Set([station.durationSeconds, ...TIMER_PRESETS])).sort(
    (a, b) => a - b,
  );

  return (
    <Dialog kicker={t.timer.title} title={station.label} onClose={closeSheet} width={440}>
      <div className={styles.clockRow}>
        <span className={styles.clock} data-warn={left <= 30}>
          {formatClock(left)}
        </span>
        <span className={styles.state}>{state}</span>
      </div>

      <div className={styles.controls}>
        <button type="button" className={`tap ${styles.primary}`} onClick={press}>
          <Icon name={running ? 'pause' : zurueck ? 'refresh' : 'play'} size={17} />
          <span>{running ? t.timer.pause : zurueck ? t.header.resetClock : t.timer.resume}</span>
        </button>
        <button type="button" className={`tap ${styles.secondary}`} onClick={reset}>
          <Icon name="refresh" size={16} />
          <span>{t.timer.reset}</span>
        </button>
      </div>

      <div className={styles.presets}>
        {presets.map((sec) => (
          <button
            key={sec}
            type="button"
            className={`tap ${styles.preset}`}
            data-on={total === sec}
            onClick={() => setTotal(sec)}
          >
            {t.timer.minutes(sec / 60)}
            {sec === station.durationSeconds && (
              <span className={styles.presetNote}>{t.timer.fromStation}</span>
            )}
          </button>
        ))}
      </div>

      <button
        type="button"
        className={`tap ${styles.hide}`}
        onClick={() => {
          setTimerShow(false);
          closeSheet();
        }}
      >
        <Icon name="hide" size={15} />
        <span>{t.timer.hide}</span>
      </button>
    </Dialog>
  );
}
